(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.NBBWatchProfileCore = api;
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var MODEL_CATALOG = {
    Apple: [
      { name: 'Apple Watch Series 11', sizes: ['42 mm', '46 mm'] },
      { name: 'Apple Watch Series 10', sizes: ['42 mm', '46 mm'] },
      { name: 'Apple Watch Series 9', sizes: ['41 mm', '45 mm'] },
      { name: 'Apple Watch Series 8', sizes: ['41 mm', '45 mm'] },
      { name: 'Apple Watch Series 7', sizes: ['41 mm', '45 mm'] },
      { name: 'Apple Watch Ultra 3', sizes: ['49 mm'] },
      { name: 'Apple Watch Ultra 2', sizes: ['49 mm'] },
      { name: 'Apple Watch SE', sizes: ['40 mm', '44 mm'] }
    ],
    Fitbit: [
      { name: 'Fitbit Charge 6', sizes: ['All editions'] },
      { name: 'Fitbit Charge 5', sizes: ['All editions'] },
      { name: 'Fitbit Charge 4', sizes: ['All editions'] },
      { name: 'Fitbit Charge 3', sizes: ['All editions'] },
      { name: 'Fitbit Versa 4', sizes: ['All editions'] },
      { name: 'Fitbit Versa 3', sizes: ['All editions'] },
      { name: 'Fitbit Versa 2', sizes: ['All editions'] },
      { name: 'Fitbit Sense 2', sizes: ['All editions'] },
      { name: 'Fitbit Sense', sizes: ['All editions'] },
      { name: 'Fitbit Luxe', sizes: ['All editions'] }
    ],
    Garmin: [
      { name: 'Garmin Fēnix 8', sizes: ['43 mm', '47 mm', '51 mm'] },
      { name: 'Garmin Fēnix 7', sizes: ['42 mm', '47 mm', '51 mm'] },
      { name: 'Garmin Forerunner 970', sizes: ['47 mm'] },
      { name: 'Garmin Forerunner 965', sizes: ['47 mm'] },
      { name: 'Garmin Forerunner 265', sizes: ['46 mm'] },
      { name: 'Garmin Forerunner 165', sizes: ['43 mm'] },
      { name: 'Garmin Instinct 3', sizes: ['45 mm', '50 mm'] },
      { name: 'Garmin Instinct 2', sizes: ['40 mm', '45 mm', '50 mm'] },
      { name: 'Garmin Venu 4', sizes: ['41 mm', '45 mm'] },
      { name: 'Garmin Venu 3', sizes: ['41 mm', '45 mm'] },
      { name: 'Garmin Vívoactive 6', sizes: ['42 mm'] },
      { name: 'Garmin MARQ', sizes: ['Model-specific'] }
    ],
    Samsung: [
      { name: 'Galaxy Watch 9', sizes: ['40 mm', '44 mm'] },
      { name: 'Galaxy Watch 8', sizes: ['40 mm', '44 mm'] },
      { name: 'Galaxy Watch 8 Classic', sizes: ['46 mm'] },
      { name: 'Galaxy Watch Ultra 2', sizes: ['47 mm'] },
      { name: 'Galaxy Watch Ultra', sizes: ['47 mm'] },
      { name: 'Galaxy Watch 7', sizes: ['40 mm', '44 mm'] },
      { name: 'Galaxy Watch 6', sizes: ['40 mm', '44 mm'] },
      { name: 'Galaxy Watch 6 Classic', sizes: ['43 mm', '47 mm'] },
      { name: 'Galaxy Watch 5', sizes: ['40 mm', '44 mm'] },
      { name: 'Galaxy Watch 5 Pro', sizes: ['45 mm'] },
      { name: 'Galaxy Watch 4', sizes: ['40 mm', '44 mm'] },
      { name: 'Galaxy Watch 4 Classic', sizes: ['42 mm', '46 mm'] }
    ]
  };

  var BRANDS = [
    { value: 'Apple', label: 'Apple Watch' },
    { value: 'Samsung', label: 'Galaxy Watch' },
    { value: 'Garmin', label: 'Garmin' },
    { value: 'Fitbit', label: 'Fitbit' },
    { value: 'Other', label: 'Another watch' },
    { value: 'Not sure', label: 'Not sure yet' }
  ];

  var USE_CASES = [
    { value: 'training', label: 'Training', detail: 'Sweat, movement and recovery', recommendation: 'Sweat-ready silicone + breathable nylon' },
    { value: 'office', label: 'Workdays', detail: 'Comfort with a polished finish', recommendation: 'Comfortable nylon + polished metal' },
    { value: 'everyday', label: 'Everyday', detail: 'One band for most of the week', recommendation: 'Versatile nylon + soft silicone' },
    { value: 'style', label: 'Going out', detail: 'A more elevated look', recommendation: 'Milanese, metal + leather looks' },
    { value: 'not_sure', label: 'A bit of everything', detail: 'Keep the advice versatile', recommendation: 'Comfort-first, exact-fit options' }
  ];

  var MATERIALS = [
    { value: 'silicone', label: 'Silicone', detail: 'Sporty and easy to clean' },
    { value: 'nylon', label: 'Nylon', detail: 'Lightweight and breathable' },
    { value: 'leather', label: 'Leather', detail: 'Classic and refined' },
    { value: 'metal', label: 'Metal', detail: 'Polished and durable' },
    { value: 'not_sure', label: 'Surprise me', detail: 'Show me the useful options' }
  ];

  var PROFILE_FIELDS = ['brand', 'model', 'size', 'usecase', 'material'];
  var CONTROL_CHARACTERS = /[\u0000-\u001f\u007f]/;

  function copyOption(option) {
    return Object.assign({}, option);
  }

  function copyModel(model) {
    return { name: model.name, sizes: model.sizes.slice() };
  }

  function clean(value) {
    return typeof value === 'string' ? value.trim() : '';
  }

  function comparable(value) {
    return clean(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  }

  function includesValue(options, value) {
    return options.some(function (option) { return option.value === value; });
  }

  function knownSizes() {
    var values = ['not_sure'];
    Object.keys(MODEL_CATALOG).forEach(function (brand) {
      MODEL_CATALOG[brand].forEach(function (model) {
        model.sizes.forEach(function (size) {
          if (values.indexOf(size) === -1) values.push(size);
        });
      });
    });
    return values;
  }

  function brandOptions() {
    return BRANDS.map(copyOption);
  }

  function brandLabel(brand) {
    var match = BRANDS.find(function (option) { return option.value === brand; });
    if (match && brand === 'Other') return 'another watch';
    if (match && brand === 'Not sure') return 'your watch';
    return match ? match.label : 'your watch';
  }

  function modelsForBrand(brand, query) {
    var needle = comparable(query);
    return (MODEL_CATALOG[brand] || [])
      .filter(function (model) { return comparable(model.name).indexOf(needle) > -1; })
      .slice(0, 8)
      .map(copyModel);
  }

  function nextStageForModel(model) {
    return model && Array.isArray(model.sizes) && model.sizes.length > 1 ? 'size' : 'usecase';
  }

  function useCaseOptions() {
    return USE_CASES.map(copyOption);
  }

  function materialOptions() {
    return MATERIALS.map(copyOption);
  }

  function normalizeAnswers(input) {
    var source = input && typeof input === 'object' && !Array.isArray(input) ? input : {};
    var keys = Object.keys(source);
    if (keys.some(function (key) { return PROFILE_FIELDS.indexOf(key) === -1; })) {
      throw new Error('invalid_profile_answer');
    }

    var answer = {};
    keys.forEach(function (key) {
      var value = clean(source[key]);
      if (!value) return;
      if (CONTROL_CHARACTERS.test(value)) throw new Error('invalid_profile_answer');
      if (key === 'brand' && !includesValue(BRANDS, value)) throw new Error('invalid_profile_answer');
      if (key === 'model' && value.length > 100) throw new Error('invalid_profile_answer');
      if (key === 'size' && knownSizes().indexOf(value) === -1) throw new Error('invalid_profile_answer');
      if (key === 'usecase' && !includesValue(USE_CASES, value)) throw new Error('invalid_profile_answer');
      if (key === 'material' && !includesValue(MATERIALS, value)) throw new Error('invalid_profile_answer');
      answer[key] = value;
    });
    return answer;
  }

  return {
    MODEL_CATALOG: Object.keys(MODEL_CATALOG).reduce(function (copy, brand) {
      copy[brand] = MODEL_CATALOG[brand].map(copyModel);
      return copy;
    }, {}),
    brandOptions: brandOptions,
    brandLabel: brandLabel,
    modelsForBrand: modelsForBrand,
    nextStageForModel: nextStageForModel,
    useCaseOptions: useCaseOptions,
    materialOptions: materialOptions,
    normalizeAnswers: normalizeAnswers
  };
});
